import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IntBorderedButtonComponent} from "./int-bordered-button.component";

@NgModule({
  imports: [CommonModule],
  declarations: [IntBorderedButtonComponent],
  exports: [IntBorderedButtonComponent]
})
export class IntBorderedButtonModule {}
